import PaCommonMixin from '../PaCommonMixin.js';

export default {
    mixins: [
        PaCommonMixin,
    ],
    props: {
        section: {
            type: [Array, Object],
            required: true,
        },
        issue: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            
        };
    },
    methods: {

        displayMorePostsForSection(section){
            let new_limit = section.item_limit + 10;
            this.$set(section, 'item_limit', new_limit);
        },

    },
}